import { render, staticRenderFns } from "./EmployeePoints.vue?vue&type=template&id=6dc46c60&scoped=true&"
import script from "./EmployeePoints.vue?vue&type=script&lang=js&"
export * from "./EmployeePoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc46c60",
  null
  
)

export default component.exports